var _g, _ellipse, _g2, _g3, _g4, _ellipse2, _g5, _g6, _ellipse3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpstriveMascot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 156,
    viewBox: "0 0 250 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_54_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.315 70.8325C210.746 67.8773 213.404 63.945 214.811 59.2918C216.015 55.3079 213.339 51.0138 211.398 47.3326C211.122 46.8101 210.894 46.2782 210.712 45.7526C210.104 44.0066 209.516 42.2111 208.493 40.6713C207.606 39.3363 206.583 37.6406 206.036 36.1936C204.656 32.5502 203.887 31.3137 204.656 28.2678C204.869 27.4261 205.322 26.8339 205.879 26.4187C207.967 24.8635 210.414 27.2058 210.979 29.7468C211.017 29.9196 211.062 30.0883 211.121 30.2551C211.475 31.2497 212.911 34.8839 215.037 34.8839C217.621 34.8839 216.83 24.2964 216.238 18.7524C216.05 16.9863 217.395 15.4103 219.171 15.3603C220.823 15.3137 222.198 16.6199 222.236 18.2725L222.559 32.2975C222.484 33.6683 224.756 32.1033 225.084 30.7703C225.841 27.6957 227.269 21.9993 228.61 17.2097C229.112 15.4186 230.968 14.3909 232.763 14.878C234.592 15.3742 235.674 17.257 235.183 19.0871L231.04 34.5064C230.773 35.3887 232.807 36.9976 233.54 36.0067L240.833 24.5185C241.884 22.8634 244.093 22.4005 245.72 23.4946C247.23 24.5101 247.704 26.5165 246.809 28.1007L241.054 38.2812C239.781 40.1129 238.785 42.1208 238.097 44.2404C238.002 44.5328 237.912 44.8254 237.815 45.1172C237.429 46.2782 236.349 49.4904 235.541 51.5099C233.882 55.6577 228.49 59.3374 227.197 63.6136L223.533 75.7351C219.544 88.9296 206.992 97.646 193.21 96.7906C185.61 96.3188 180.379 88.9605 182.431 81.6273L184.061 75.8011C192.455 78.3067 201.137 76.1527 207.315 70.8325Z",
    fill: "url(#paint0_radial_54_128)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_54_128)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.017,
    cy: 77.5135,
    rx: 100.017,
    ry: 77.5135,
    fill: "url(#paint1_radial_54_128)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.017,
    cy: 77.5135,
    rx: 100.017,
    ry: 77.5135,
    fill: "url(#paint2_radial_54_128)",
    fillOpacity: 0.7,
    style: {
      mixBlendMode: "soft-light"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_54_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.026 79.0137C141.066 90.0613 123.156 99.0172 100.018 99.0172C76.8786 99.0172 58.9691 90.0613 50.0088 79.0137",
    stroke: "#8374CA",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_54_128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.021,
    cy: 56.0084,
    rx: 15.0026,
    ry: 20.0035,
    fill: "#ECECEC"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_54_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M134.337 50.0077C134.337 50.0077 131.523 36.0052 120.021 36.0052C108.519 36.0052 105.705 50.0077 105.705 50.0077C113.341 41.4724 126.701 41.4724 134.337 50.0077Z",
    fill: "#9183D2"
  }))), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.021,
    cy: 60.009,
    rx: 5.00087,
    ry: 7.00122,
    fill: "#7060B6"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_54_128)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0134,
    cy: 56.0103,
    rx: 15.0026,
    ry: 20.0035,
    fill: "#ECECEC"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_54_128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M94.3298 50.0096C94.3298 50.0096 91.5162 36.0072 80.014 36.0072C68.5118 36.0072 65.6982 50.0096 65.6982 50.0096C73.3338 41.4743 86.6943 41.4743 94.3298 50.0096Z",
    fill: "#9183D2"
  }))), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80.0136,
    cy: 60.011,
    rx: 5.00087,
    ry: 7.00122,
    fill: "#7060B6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_54_128",
    x: 181.982,
    y: 14.7568,
    width: 66.2773,
    height: 85.0918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_54_128"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_54_128",
    x: 0,
    y: 0,
    width: 201.035,
    height: 158.027,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_54_128"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_54_128",
    x: 47.0088,
    y: 77.0137,
    width: 106.018,
    height: 26.0039,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_54_128",
    x: 89.0186,
    y: 31.0049,
    width: 62.0049,
    height: 72.0068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_54_128",
    x: 89.7051,
    y: 31.0049,
    width: 60.6318,
    height: 46.0029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_54_128",
    x: 49.0107,
    y: 31.0068,
    width: 62.0049,
    height: 72.0068,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_54_128",
    x: 49.6982,
    y: 31.0068,
    width: 60.6318,
    height: 46.0029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_128"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_128",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_54_128",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(227.941 11.7969) rotate(106.819) scale(94.8026 46.9679)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6470DE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_54_128",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.017) rotate(90) scale(155.027 200.035)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.251268,
    stopColor: "#C7B5FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333EAB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_54_128",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(100.017 77.5135) rotate(90) scale(77.5135 100.017)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpstriveMascot);
export default __webpack_public_path__ + "static/media/UpstriveMascot.6e73dc0b07d355a2292e96b5807731e0.svg";
export { ForwardRef as ReactComponent };